/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";

export default function Harita(props) {
  const [mapUrl, setMapUrl] = useState(props.embed);

  useEffect(() => {
    if (props.embed) {
      // URL'den koordinatları çıkart
      const match = props.embed.match(/!2d([-.\d]+)!3d([-.\d]+)!/);

      if (match) {
        const lng = match[1];
        const lat = match[2];

        // Direkt marker eklenmiş harita URL'si oluştur
        const directMapUrl = `https://www.google.com/maps?q=${lat},${lng}&z=15&t=m&output=embed`;
        setMapUrl(directMapUrl);
      } else {
        setMapUrl(props.embed);
      }
    } else {
      // Varsayılan URL için de aynı işlem yapılabilir
      const defaultUrl =
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1671!2d30.5213153!3d39.7685384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cc1603bc679897%3A0x84670b9962a6990!2sRBA%20Gayrimenkul!5e0!3m2!1str!2str!4v1642869952544!5m2!1str!2str";
      const defaultMatch = defaultUrl.match(/!2d([-.\d]+)!3d([-.\d]+)!/);

      if (defaultMatch) {
        const lng = defaultMatch[1];
        const lat = defaultMatch[2];
        const directMapUrl = `https://www.google.com/maps?q=${lat},${lng}&z=15&t=m&output=embed`;
        setMapUrl(directMapUrl);
      } else {
        setMapUrl(defaultUrl);
      }
    }
  }, [props.embed]);

  return (
    <div className={`col-lg-${props.colNumber}`}>
      <div id="map">
        <iframe
          src={mapUrl}
          width="100%"
          height="500px"
          style={{
            border: "0",
            borderRadius: "10px",
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.15)",
          }}
          allowFullScreen=""
        ></iframe>
      </div>
    </div>
  );
}
